import React, { Component } from "react";
import Select from "react-select";

import { monthName } from "../../../../utils/CommonFunction";

export default class ViewPreviousLeaveBalanceButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedViewLeaveBalanceYear: undefined,
      viewLeaveBalanceYear: undefined,
    };
  }

  get viewLeaveBalanceYearDropDownList() {
    return this.props.leaveCarryCalculatedYears.map((obj) => {
      if (obj.yearStart === obj.yearEnd) {
        return {
          label: `${obj.yearStart} ${monthName(obj.monthStart)} to ${monthName(
            obj.monthEnd
          )}`,
          value: obj.yearStart, // year start is enough
        };
      }
      return {
        label: `${obj.yearStart} ${monthName(obj.monthStart)} to ${
          obj.yearEnd
        } ${monthName(obj.monthEnd)}`,
        value: obj.yearStart, // year start is enough
      };
    });
  }

  handleViewLeaveBalanceYear = (event) => {
    this.setState({
      selectedViewLeaveBalanceYear: event,
      viewLeaveBalanceYear: event.value,
    });
  };

  render() {
    return (
      <div style={{ margin: "0px 10px" }}>
        <h3>View Leave Balance</h3>
        <div className="row mt20">
          <div className="row col-lg-8">
            <div className="col-sm-5">
              <Select
                options={this.viewLeaveBalanceYearDropDownList}
                value={this.state.selectedViewLeaveBalanceYear} // Previous Year
                onChange={this.handleViewLeaveBalanceYear}
                className="react-select-container checkValidate"
                classNamePrefix="react-select"
              />
            </div>
            <div className="col-sm-3">
              <button
                type="button"
                className="btn btn-primary"
                onClick={() =>
                  this.props.viewLeaveBalance(this.state.viewLeaveBalanceYear)
                }
              >
                View
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
